import { render, staticRenderFns } from "./DriverMailStatusIcon.vue?vue&type=template&id=290c6b96&scoped=true&lang=pug"
import script from "./DriverMailStatusIcon.vue?vue&type=script&lang=js"
export * from "./DriverMailStatusIcon.vue?vue&type=script&lang=js"
import style0 from "./DriverMailStatusIcon.vue?vue&type=style&index=0&id=290c6b96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290c6b96",
  null
  
)

export default component.exports